<ml-loader [title]="'init.waiting_screen.title' | translate" [subtitle]="'init.waiting_screen.subtitle' | translate"></ml-loader>
